export function inputFile() {
    $("input[type='file']").on("change", function () {
        let $this = $(this);
        let fileName = $this.val().split("/").pop().split("\\").pop();
        let $fileButton = $(".file-button");

        if (fileName !== "") {
            $fileButton.addClass("hide");
        } else {
            $fileButton.removeClass("hide");
        }

        $this.parent().find(".file-name-filed").html(fileName);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/inputFile.js